module.exports =
  accepted:   [Boolean]
  click:
    accepted:   [Boolean, Function]
    value:      true
  move:
    accepted:   [Boolean, Function]
    value:      true
  out:
    accepted:   [Boolean, Function]
    value:      true
  over:
    accepted:   [Boolean, Function]
    value:      true
  value:      true
